export enum ReAuthenticationResultEnum {
    Success = 'success',
    AzureLoginFailed = 'azureLoginFailed',
    Failed = 'failed',
}
